import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';
import RequiredValidator from './RequiredValidator';

export class AdviserFeesOrExternalValidator extends BaseValidator {
    static key = 'adviserFeesOrExternal';

    /**
     * Valid when:
     * - adviser_fees_agreed_externally is strictly true, OR
     * - either fee_percentage_of_investment or fee_amount_per_annum is present/valid.
     *
     * Treats any non-true value (false, null, undefined) as \"no external agreement\".
     */
    static validator(adviserFeesAgreedExternally = null, feePercentageOfInvestment = null, feeAmountPerAnnum = null) {
        const hasExternalAgreement = adviserFeesAgreedExternally === true;

        const hasValidPercentage =
            RequiredValidator.validator(feePercentageOfInvestment) === true;
        const hasValidAmount = RequiredValidator.validator(feeAmountPerAnnum) === true;

        const hasValidFees = hasValidPercentage || hasValidAmount;

        if (hasExternalAgreement || hasValidFees) {
            return true;
        }

        return i18n.t('validator.adviser_fees_or_external');
    }

    static arguments() {
        return [];
    }
}

export default AdviserFeesOrExternalValidator;

